<template>
  <div>
    <div class="mb-4 flex justify-content-between align-items-center">
      <span v-if="id > 0" class="pr-2 mr-2 font-bold text-2xl"
        >Retur Penjualan - Edit</span
      >
      <span v-else class="pr-2 mr-2 font-bold text-2xl"
        >Retur Penjualan - Tambah</span
      >
      <div>
        <i class="pi pi-home mr-2"></i>
        <span v-if="id > 0" class="font-small"
          >/ Kembali / Retur Penjualan / Edit</span
        >
        <span v-else class="font-small"
          >/ Kembali / Retur Penjualan / Tambah</span
        >
      </div>
    </div>
    <form-retur-penjualan :id="id" />
  </div>
</template>

<script>
import FormReturPenjualan from '@/components/penjualan/FormReturPenjualan'

export default {
  components: {
    FormReturPenjualan,
  },
  data() {
    return {
      id: parseInt(this.$route.params.id),
    }
  },
}
</script>
